import { useState, useEffect, useMemo } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { TypeAhead } from '@components';

type FilterProps = {
  meta: any;
  header?: any;
  filterData: any;
  onChange: (val: any) => void;
};

export const FilterTypeAhead = (props: FilterProps) => {
	const { meta, header, filterData, onChange } = props;
	const filterOptions = meta?.filterOptions?.options ?? [];
	const placeholder = meta?.filterOptions?.allowPlaceHolder ?? '';

	const [inputVal, setInputVal] = useState<string>(''); // typed text
	const [selectOptions, setSelectOptions] = useState<any[]>([]);

	// Set initial selected value if provided
	useEffect(() => {
		if (filterData?.value) {
			const matched = selectOptions.find((opt) => opt.value === filterData.value);
			const label = typeof matched?.label === 'string' ? matched.label : '';
			setInputVal(label);
		} else {
			setInputVal('');
		}
	}, [filterData, selectOptions]);

	// Transform options to proper format
	const generateSelectOptions = (options: any[]) => {
		return options.map((opt) =>
			typeof opt === 'string' ? { value: opt, label: opt } : opt
		);
	};

	useEffect(() => {
		setSelectOptions(generateSelectOptions(filterOptions));
	}, [meta]);

	// Filter options based on input
	const filteredOptions = useMemo(() => {
		if (!inputVal) return selectOptions;
		const search = inputVal.toLowerCase();
		return selectOptions.filter((opt) =>
			opt.label?.toLowerCase?.().includes(search)
		);
	}, [inputVal, selectOptions]);

	// Called when user selects an item
	const handleSelected = (v: any | string) => {
		const value = typeof v === 'string' ? v : v.value;
		const label = typeof v === 'string' ? v :
			typeof v.label === 'string' ? v.label : '';

		setInputVal(label);
		const newFilterData = {
			...filterData,
			value,
			columnField: meta?.databaseLocation ?? header,
			operatorValue: 'is',
		};
		onChange(newFilterData);
	};

	return (
		<TypeAhead
			name='Filter-Option-Type-Ahead'
			value={inputVal}
			onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
				setInputVal(e.target.value)
			}
			onSelected={handleSelected}
			options={filteredOptions}
			placeholder={placeholder}
			Icon={SearchIcon}
			keepErrorSpace={false}
		/>
	);
};
